import React from "react";
import VendorsAvailability from "../components/VendorsAvailability/VendorsAvailability";

export default function VendorsAvailabilityView() {
  return <VendorsAvailability />;
}
